import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { JupiterState } from '../@store/state';
import { filter } from 'rxjs';
import { RouterModule } from '@angular/router';
import { JupiterDetailsHeaderComponent } from './header/header.component';
import { TsComponent } from '../@components/ts.component';
import { EntityActions } from '@jupiter-actions';

@Component({
  selector: 'jupiter-details',
  standalone: true,
  imports: [RouterModule, JupiterDetailsHeaderComponent],
  templateUrl: './details.component.html',
  styleUrl: './details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JupiterDetailsComponent extends TsComponent implements OnDestroy, OnInit {
  ngOnDestroy(): void {
    this.store.dispatch(new EntityActions.Clear());
  }

  ngOnInit(): void {
    this.activatedRoute.params
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params: { relatedToKey; viewId; recordId; tabId }) => {
        if (!this.store.selectSnapshot(JupiterState.getRelatedTo)) {
          this.router.navigateByUrl(`/space/void?return=${this.router.url}`, { skipLocationChange: true });
          return;
        } else {
          this.store.dispatch(new EntityActions.Load(params.recordId));
        }
      });

    this.store
      .select(JupiterState.getEntity)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((x) => !!x),
      )
      .subscribe((entity) => {
        if (!this.activatedRoute.firstChild) {
          if (entity.template.definition.tabs?.length) {
            this.router.navigate(['tab', entity.template.definition.tabs[0].id], { relativeTo: this.activatedRoute });
          }
        }
      });
  }
}
